import { navigate } from 'gatsby';
import md5 from 'md5';
import React from 'react';

import Checkbox from '../components/checkbox';
import { Form, FormError, FormForgotten, FormHeader, FormItems, FormSubmit } from '../components/form';
import Input from '../components/input';
import Layout from '../components/layout';
import Link from '../components/link';
import { Content, ContentDesc, Footer, FooterLinkBack, Header, Page } from '../components/page';
import Seo from '../components/seo';
import SvgArrowRight from '../svg/arrowRight';
import datoCmsGrahpQl from '../utils/dato-cms-graphql';
import { createOrUpdateUserData } from '../utils/userData';

export default class Login extends React.Component {
  state = {
    form: {},
    submitProcessing: false,
    user: undefined,
    rememberUser: false,
  }

  submitHandler = event => {
    this.setState({ submitProcessing: true })
    this.checkUserExists()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  checkUserExists = () => {
    const query = `expert(filter: {email: {eq: "${
      this.state.form.email
    }"}, password: {eq: "${this.state.form.password}"}}) {
      name
      email
      id
      lessons
      emailisverified
    }`

    return new Promise(resolve => datoCmsGrahpQl(query, resolve)).then(
      ({ expert }) => {
        if (this._isMounted)
          this.setState({
            user: expert ? true : false,
            submitProcessing: false,
          })
        if (this._isMounted && expert) this.handleSuccessLogin(expert)
      }
    )
  }

  handleSuccessLogin = userData => {
    if (!userData.emailisverified) {
      navigate(`/email-not-confirmed`, { state: { ...userData } })
      return
    }

    createOrUpdateUserData({
      name: userData.name,
      lessons: userData.lessons,
      rememberUser: this.state.rememberUser,
      userId: userData.id,
      email: userData.email,
    })

    navigate(
      (this.props.location.state && this.props.location.state.pageAfterLogin) ||
        '/lessons'
    )
  }

  componentDidMount() {
    this._isMounted = true
  }

  handleChange = event => {
    const name = event.target.name
    const value =
      event.target.type !== 'checkbox' || event.target.type !== 'radio'
        ? event.target.type === 'password'
          ? md5(event.target.value)
          : event.target.value
        : event.target.checked

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }))
  }

  handleRemember = event => {
    this.setState({ rememberUser: event.target.checked })
  }

  render() {
    //if (getUserData()) clearUserData()

    return (
      <Layout>
        <Seo title="Log in" />

        <Page type="short">
          <Form onSubmit={this.submitHandler}>
            <Header closeUrl="/lessons">
              {(this.props.location.state &&
                this.props.location.state.loginText && (
                  <span className="_color-danger">
                    {this.props.location.state.loginText}
                  </span>
                )) ||
                'Log in to online guide'}
            </Header>
            <Content>
              <FormHeader>
                <ContentDesc>
                  {(this.props.location.state &&
                    this.props.location.state.loginText && (
                      <span className="_color-danger">
                        {this.props.location.state.loginText}
                      </span>
                    )) ||
                    'Log in to online guide'}
                </ContentDesc>
                <h1>Enter your details.</h1>
              </FormHeader>

              <FormItems>
                <dt>
                  <label htmlFor="email">Your email</label>
                </dt>
                <dd>
                  <Input
                    size="lg"
                    id="email"
                    type="email"
                    name="email"
                    required={true}
                    onChange={this.handleChange}
                  />
                  <p className="validation">WRONG</p>
                </dd>

                <dt>
                  <label htmlFor="password">password</label>
                </dt>
                <dd>
                  <Input
                    size="lg"
                    id="password"
                    type="password"
                    name="password"
                    required={true}
                    onChange={this.handleChange}
                  />
                  <p className="validation">WRONG</p>
                </dd>
              </FormItems>

              <FormForgotten>
                <Link to="/forgotten-password">
                  Forgotten password? <SvgArrowRight />
                </Link>
              </FormForgotten>

              <Checkbox value="remember me" onChange={this.handleRemember} />

              {this.state.user !== undefined && !this.state.user && (
                <FormError>USER OR PASSWORD ARE NOT CORRECT</FormError>
              )}
            </Content>
            <Footer>
              <FormSubmit disabled={this.state.submitProcessing}>
                Log in
              </FormSubmit>
              <FooterLinkBack to="/register">
                New to the online guide?
                <SvgArrowRight />
              </FooterLinkBack>
            </Footer>
          </Form>
        </Page>
      </Layout>
    )
  }
}
